import React from "react";
import Grid from "@mui/material/Unstable_Grid2"; // MUI v5 Grid v2
import ChoiceOption from "./ChoiceOption";

/**
 * OptionList - displays a list of single-select options in a responsive grid
 */
export default function OptionList({
  options,
  value,
  onChange,
  columns = { xs: 12 },
  expandedOptionId = null, // ID of the option that is currently expanded
}) {
  return (
    <div>
      <Grid container spacing={2}>
        {options.map((opt) => (
          <Grid key={opt.id} {...columns}>
            <ChoiceOption
              label={opt.label}
              description={opt.description}
              selected={value === opt.id}
              onClick={() => onChange(opt.id)}
              disabled={opt.disabled}
              icon={opt.icon}
              endAdornment={opt.endAdornment}
              expanded={expandedOptionId === opt.id}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
